import type { interfaces } from "inversify";
import LocalizationService from "services/localizationService";
import { Modules } from "config";
import type RefundApprovedResponse from "entities/refundApprovedResponse";
import ConfirmViewModel from "../../confirmViewModel";

export default class RefundsDisapprovalViewModel extends ConfirmViewModel {
  constructor(public refunds: RefundApprovedResponse[], private localizationService: LocalizationService) {
    super();
  }

  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `bankAccountBlacklists.refundsDisapproval.${code}`, size);
  }

  translateAttribute(attribute: keyof RefundApprovedResponse) {
    return this.localizationService.translateAttribute("refundApprovedResponse", attribute);
  }

  static Factory({ container }: interfaces.Context) {
    return (refunds: RefundApprovedResponse[]) => new RefundsDisapprovalViewModel(refunds, container.get(LocalizationService));
  }
}
